import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function DSection4() {
    const { useLang, useEffect, useRef } = useGlobal();
    const { t } = useLang('xstream');

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const fadeIn = (el: any) => {
        const layoutH = window?.innerHeight || 750;
        const target = `.xstream_h5 .D_section4 ${el}`;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: layoutH / 10,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: layoutH / 10,
            triggerHook: 1,
            duration: layoutH / 10,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: (layoutH / 10) * 2,
            triggerHook: 0,
            duration: (layoutH / 10) * 8,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 1 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        fadeIn('.title');
        fadeIn('.desc');
    }, []);

    const v4Ref = useRef(null);
    useEffect(() => {
        const videoEl = document.querySelector('.D_section4 .videoBox') as HTMLElement;
        const vH = videoEl?.offsetHeight || 667;
        new ScrollMagic.Scene({
            triggerElement: videoEl,
            triggerHook: 1,
            offset: vH / 2,
        })
            .on('enter', () => {
                v4Ref?.current?.play();
            })
            .addTo(controller);

        const video4El = document.querySelector('.D_section4 #xstream-video4_h5') as HTMLElement;
        new ScrollMagic.Scene({
            triggerElement: '.D_section4 .videoBox',
            triggerHook: 1,
        })
            .on('enter', () => {
                if (video4El) {
                    video4El.currentTime = 0;
                }
            })
            .addTo(controller);
    }, []);

    return (
        <div className={`D_section4 ${css.D_section4}`}>
            <div className="videoBox">
                <EFVideo
                    id="xstream-video4_h5"
                    sources={['/media/x-stream/h5/05_BMS.webm', '/media/x-stream/h5/05_BMS.mp4']}
                    ref={v4Ref}
                    className="video_fast"
                    width="100%"
                    autoPlay={false}
                    loop={false}
                />
                <div className="textBox">
                    <p className="title">{t('section_5_title')}</p>
                    <p className="desc">{t('section_5_desc')}</p>
                </div>
            </div>
        </div>
    );
}
